import React, { useRef, useState } from 'react'
import "./contact.css"
import Lottie from "react-lottie";
import Downs from '@mui/icons-material/ArrowDropDown'
import Sends from '@mui/icons-material/Send'
import animationData from "../data/watsap chat lotte.json";
import animationData2 from "../data/watsap lotte.json";
import myLogo from "../imgz/mindzlogo.png"
import {socialMedia} from "../data/index";


function Contact({contactRef}) {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice",
        },
      };

      const defaultOptions2 = {
        loop: true,
        autoplay: true,
        animationData: animationData2,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice",
        },
      };
       const [firstCat, setFirstCat] = useState("")
       const [firstCat2, setFirstCat2] = useState("")
       const [firstCat3, setFirstCat3] = useState("")
       const [company, setCompany] = useState("")
       const [cooperate, setCooperate] = useState("")
       const [about, setAbout] = useState("")
       const [name, setName] = useState("")
       const [rot, setRot] = useState(false)
       const [rot2, setRot2] = useState(false)
       const [rot3, setRot3] = useState(false)
       const [active, setActive] = useState(false)
       const [active2, setActive2] = useState(false)
       const [active3, setActive3] = useState(false)
       const [active4, setActive4] = useState(false)
       const inputRef = useRef(null); // Create a reference to the input element
       const inputRef2 = useRef(null);
       const inputRef3 = useRef(null);
       const inputRef4 = useRef(null);
       const catRef = useRef(null);
       const catRef2 = useRef(null);
       const catRef3 = useRef(null);
       const textareaRef = useRef(null);
       const [showu, setShowu] = useState(false) 
       const handleMouseEnter = () => {
            setActive(true)
            inputRef.current.focus(); // Focus the input element when hovering over the container
        };
        const handleMouseEnter2 = () => {
            setActive2(true)
            inputRef2.current.focus(); // Focus the input element when hovering over the container
        };
        const handleMouseEnter3 = () => {
            setActive3(true)
            inputRef3.current.focus(); // Focus the input element when hovering over the container
        };
         
        const slides = () =>{
            if(!rot){
                setRot(true)
            }else{
                setRot(false)
            }
            
        }
        const slides2 = () =>{
            if(!rot2){
                setRot2(true)
            }else{
                setRot2(false)
            }
            
        }
  
        const selectCat = (cats) =>{
            if(catRef.current){
                catRef.current.innerText = cats
                setFirstCat(cats)
            }
            if(rot){
                setRot(false)
            }
        }

        const selectCat2 = (cats) =>{
            if(catRef2.current){
                catRef2.current.innerText = cats
                setFirstCat2(cats)
            }
            if(rot2){
                setRot2(false)
            }
        }
        
        const selectCat3 = (cats) =>{
            if(catRef.current){
                catRef.current.innerText = cats
                setFirstCat(cats)
            }
            if(rot){
                setRot(false)
            }
        }

        const handleresizing = (e) => {
            setAbout(e.target.value)
            const textsz = textareaRef.current;
            if(textsz){
                textsz.style.height = 'auto'
                textsz.style.height = `${textsz.scrollHeight}px`
            }
        }

// Your WhatsApp number (without the leading 0)
const phoneNumber = '+255625893497'; // Your number

const sendMessage = () => {
  console.log("Preparing to send message");

  // Check if the mandatory fields are filled
  if (!firstCat || !firstCat2 || !name || !about) {
    alert("Please fill out Category 1, Category 2, Name, and About fields.");
    return;
  }

  // Build the message string using the form data
  let message = "Hello, I would like to ask for a for the following project details:\n";

  // Add mandatory fields to the message
  message += `\nCategory 1 (Individual/Company): ${firstCat}\n`;
  message += `Category 2 (Project Type - Website/Android App/iOS App/Hybrid): ${firstCat2}\n`;
  message += `Name: ${name}\n`;
  message += `About the Project: ${about}\n`;

  // Add optional fields if available
  if (company) message += `Company: ${company}\n`;
  if (cooperate) message += `Cooperate Info: ${cooperate}\n`;

  console.log("Message:", message); // Log the message to check its format

  // WhatsApp URL with pre-filled message
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  console.log("WhatsApp URL:", whatsappUrl); // Log the URL to check its format

  // Open WhatsApp in a new tab
  window.open(whatsappUrl, '_blank');
};

  
  
    return (
    <div className='contactmain' id="contact" ref={contactRef}  >
        <h1 className="heading"  >
        Contact <span className="highlighted-text"> Us</span> Now!
      </h1>

      
            <div className="watsapContainer" >
            <Lottie options={defaultOptions}  />
            </div>
       <div className="thebutton" >
            <div className="contact-button" onClick={()=>setShowu(true)} >
                    <h2 className="contbuttext" >Click to Chat</h2>
                    <div className="watsapContainer2" >
                    <Lottie options={defaultOptions2}  />
                    </div>
            </div>
       </div>

       <div className="mylogos" >
               <img src={myLogo} alt="" className="mylogoPic" />
       </div>

       

       <div className="thefooter" >
       

       
        <h2 className="copyright">
          Copyright © 2024 Mastermindz Tech
        </h2>

        <div className="footIcons">
          {socialMedia.map((info) => (
            <div
              key={info.id}
              className="w-10 h-10 cursor-pointer flex justify-center items-center backdrop-filter backdrop-blur-lg saturate-180 bg-opacity-75 bg-black-200 rounded-lg border border-black-300"
            >
              <img src={info.img} alt="icons" width={20} height={20} />
            </div>
          ))}
        </div>


       </div>
       
       <div className={`${showu ? "contactform" : "contactform2"}`} >
            <div className="contactinputs" onMouseEnter={handleMouseEnter} >
                 
                 <h2 className={`${active ? "pretext2" : "pretext"}`} >Full Name</h2>
                 <input  ref={inputRef} 
                    type='text' 
                    placeholder='Full Name' 
                    className={`${active ? "inputvalue2" : "inputvalue"}`}
                    onChange={(e)=>setName(e.target.value)}
                    />
            </div>

          
            
             
            <div className='navcover' onClick={slides} 
            >                  
                  <h2 className='navZ' ref={catRef} >Individual or company or cooperate?</h2>
                        <div className={`${rot ? 'navIconz-rotated' : 'navIconz'}`} >
                            <Downs fontSize='inherit' />
                        </div>
           </div>
             <div className={`testDiv2 ${rot ? 'testDiv2-expanded' : 'testDiv2-collapsed'}`}
                      
            >
               <h2 className="categourii" onClick={()=>selectCat("Individual")} >Individual</h2>
               <h2 className="categourii" onClick={()=>selectCat("Company")} >Company</h2>
               <h2 className="categourii" onClick={()=>selectCat("Cooperate")} >Cooperate</h2>
 
            </div>

            {firstCat === "Company" && (
                <div className="contactinputs" onMouseEnter={handleMouseEnter2} >
                 
                 <h2 className={`${active2 ? "pretext2" : "pretext"}`} >Company Name</h2>
                 <input  ref={inputRef2} 
                    type='text' 
                    placeholder='Company name' 
                    className={`${active2 ? "inputvalue2" : "inputvalue"}`} />
            </div>

            )}
            {firstCat === "Cooperate" && (
                <div className="contactinputs" onMouseEnter={handleMouseEnter3} >
                 
                 <h2 className={`${active3 ? "pretext2" : "pretext"}`} >Cooperate Name</h2>
                 <input  ref={inputRef3} 
                    type='text' 
                    placeholder='Cooperate name' 
                    className={`${active3 ? "inputvalue2" : "inputvalue"}`} />
            </div>

            )}

                <div className='navcover' onClick={slides2} 
                            >                  
                  <h2 className='navZ' ref={catRef2} >What do you wanna build?</h2>
                        <div className={`${rot2 ? 'navIconz-rotated' : 'navIconz'}`} >
                            <Downs fontSize='inherit' />
                  </div>
           </div>

           <div className={`testDiv2 ${rot2 ? 'testDiv2-expanded' : 'testDiv2-collapsed'}`}
                      
            >
               <h2 className="categourii" onClick={()=>selectCat2("Website")} >Website</h2>
               <h2 className="categourii" onClick={()=>selectCat2("Android App")} >Android App</h2>
               <h2 className="categourii" onClick={()=>selectCat2("IOS App")} >IOS App</h2>
               <h2 className="categourii" onClick={()=>selectCat2("Hybrid App")} >Hybrid Android & IOS App</h2>
 
            </div>

             <textarea
              placeholder='Tell us a little bit about your Project ....'
              className="textareas"
              onInput={handleresizing}
              value={about}
              ref={textareaRef}
             />

             <div className="thelast" >
                    <h2 onClick={()=>setShowu(false)} 
                    className="cancel" >Cancel</h2>
                    <div className="sendy" onClick={sendMessage} >
                        <h2 className="senda" >Send</h2>
                        <div className="sendicon" >
                            <Sends fontSize="inherit" />
                        </div>
                    </div>
             </div>

       </div>

    </div>
  )
}

export default Contact